import { Component, computed, input, output } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faArrowsRotate, faFilter } from "@fortawesome/free-solid-svg-icons";
import { TranslatePipe } from "@ngx-translate/core";

type BaseWidgetData = {
  isDuo: boolean;
};

export type SimpleWidgetData = BaseWidgetData & {
  label: string;
  data: number | string | unknown;
  labelClasses?: string;
  dataClasses?: string;
};

export type ItemListWidgetData = BaseWidgetData & {
  items: { label: string; data: number | string | unknown }[];
};

export type SymbolWidgetData = BaseWidgetData &
  SimpleWidgetData & {
    symbol: string;
  };

export type IconWidgetData = BaseWidgetData &
  SimpleWidgetData &
  SymbolWidgetData & {
    icon: string;
  };

@Component({
  selector: "adaa-ribbon",
  imports: [FontAwesomeModule, TranslatePipe],
  templateUrl: "./ribbon.html",
  styleUrl: "./ribbon.scss",
})
export class RibbonComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  widgetData = input.required<(SimpleWidgetData | ItemListWidgetData | SymbolWidgetData | IconWidgetData | any)[]>();
  showLogo = input<boolean>(false);
  showFilterIcon = input<boolean>(false);
  showRefreshIcon = input<boolean>(true);
  filterApplied = input<boolean>(false);

  refreshClicked = output();
  filterClicked = output();

  readonly refreshIcon = faArrowsRotate;
  readonly filterIcon = faFilter;

  /** Narrows the cell basis as the ribbon gets busier, so a dense ribbon still fits on one row. */
  readonly cellMin = computed(() => {
    const count = this.widgetData().length;

    if (count >= 8) return "170px";
    if (count >= 7) return "200px";
    return "215px";
  });
}
